import { useMedia } from 'react-use';

export const useDevicesScreen = () => {
  const isMobile = useMedia('(max-width:680px)', false);
  const isTablet = useMedia(
    '(min-width: 681px) and (max-width: 1120px)',
    false,
  );
  const isDesktop = useMedia(
    '(min-width: 1121px) and (max-width: 1919px)',
    false,
  );
  const isLargeDesktop = useMedia('(min-width: 1920px)', true);

  return { isMobile, isTablet, isDesktop, isLargeDesktop };
};
